import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootEpic, SystemConfig } from "common/define-type";
import { filter, map, switchMap } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import IdentityApi from "api/identity/identity.api";
import pkmApi from "api/pkm/pkm.api";
import ProfileApi from "api/profile/prf.api";
import InventoryApi from "api/inv/inv.api";
import ListHotelApi from "api/hotel/hotel.api";
import functionPkmApi from "api/pkm/function.api";
import HotelConfigApi from "api/hcfg/hcfg.api";
import CashierAPI from "api/cashier/cashier.api";

interface BootstrapState {
    systemConfig: SystemConfig;
    isSuccess: boolean
}
const PATH_SYSTEM_CONFIG = `${process.env.PUBLIC_URL}/assets/system-config.json`;
const IS_CONFIG_LOCAL = false;
const DEFAULT_CONFIG: SystemConfig = {
    protocol: 'http',
    hostIdentity: 'api.tingconnect.com',
    hostPkm: "localhost:2104",
    hostTingConnect: "api.tingconnect.com",
    hostHCFG: "localhost:2101",
    hostINV: "localhost:2102",
    hostPRF: "localhost:2103",
    hostRSVN: "localhost:2104",
    hostCashier: "localhost:2105"
};
const initialStateBootstrap: BootstrapState = {
    systemConfig: DEFAULT_CONFIG,
    isSuccess: false,
};

function updateHostService(host: SystemConfig) {
    IdentityApi.host = host.hostIdentity;
    pkmApi.host = host.hostPkm;
    functionPkmApi.host = host.hostPkm;
    ProfileApi.profileHost = host.hostPRF;
    InventoryApi.inventoryHost = host.hostINV;
    HotelConfigApi.hcfgHost = host.hostHCFG;
    ListHotelApi.host = host.hostIdentity;
    CashierAPI.host = host.hostCashier;
}
const bootstrapSlice = createSlice({
    name: 'bootstrap',
    initialState: initialStateBootstrap,
    reducers: {
        setSysytemConfig: (state, action: PayloadAction<SystemConfig>) => {
            updateHostService(action.payload);
            state.systemConfig = action.payload;
            state.isSuccess = true;
        },
        fetchConfig: (state) => {
            state.isSuccess = false;
        }
    }
})

const bootstrap$: RootEpic = (action$) => action$.pipe(
    filter(fetchConfig.match),
    switchMap(() => {
        return ajax.getJSON(PATH_SYSTEM_CONFIG, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        }).pipe(map(res => {
            const config = IS_CONFIG_LOCAL ? DEFAULT_CONFIG : res as SystemConfig;
            return bootstrapSlice.actions.setSysytemConfig(config)
        }))
    })
);


export const BoostrapEpics = [
    bootstrap$
];

export const { fetchConfig } = bootstrapSlice.actions;
export const bootstrapReducer = bootstrapSlice.reducer;